import { Instance } from "mobx-state-tree"
import { ChannelModelBase } from "./ChannelModel.base"

/* The TypeScript type of an instance of ChannelModel */
export interface ChannelModelType extends Instance<typeof ChannelModel.Type> {}

/* A graphql query fragment builders for ChannelModel */
export { selectFromChannel, channelModelPrimitives, ChannelModelSelector } from "./ChannelModel.base"

/**
 * ChannelModel
 */
export const ChannelModel = ChannelModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self))
    }
  }))
